import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/auth";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Home from "@/pages/Home";
import StartDay from "@/pages/StartDay";
import EndDay from "@/pages/EndDay";
import AddVisit from "@/pages/AddVisit";
import DoctorVisit from "@/pages/DoctorVisit";
import RetailerVisit from "@/pages/RetailerVisit";
import StockistVisit from "@/pages/StockistVisit";
import Summary from "@/pages/Summary";
import FollowUps from "@/pages/FollowUps";
import Profile from "@/pages/Profile";
import Expenses from "@/pages/Expenses";
import MRDashboard from "@/pages/MRDashboard";
import ManagerDashboard from "@/pages/ManagerDashboard";
import Admin from "@/pages/Admin";

function Loading() {
  return <div className="min-h-screen grid place-items-center text-slate-400">Loading…</div>;
}

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Root() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "manager") return <Navigate to="/manager" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Home />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function AppRoutes() {
  const mr = ["mr"];
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/" element={<Root />} />
      <Route path="/start-day" element={<Protected roles={mr}><StartDay /></Protected>} />
      <Route path="/end-day" element={<Protected roles={mr}><EndDay /></Protected>} />
      <Route path="/add-visit" element={<Protected roles={mr}><AddVisit /></Protected>} />
      <Route path="/visit/doctor" element={<Protected roles={mr}><DoctorVisit /></Protected>} />
      <Route path="/visit/retailer" element={<Protected roles={mr}><RetailerVisit /></Protected>} />
      <Route path="/visit/stockist" element={<Protected roles={mr}><StockistVisit /></Protected>} />
      <Route path="/summary" element={<Protected roles={mr}><Summary /></Protected>} />
      <Route path="/followups" element={<Protected roles={mr}><FollowUps /></Protected>} />
      <Route path="/profile" element={<Protected roles={mr}><Profile /></Protected>} />
      <Route path="/expenses" element={<Protected roles={mr}><Expenses /></Protected>} />
      <Route path="/dashboard" element={<Protected roles={mr}><MRDashboard /></Protected>} />
      <Route path="/manager" element={<Protected roles={["manager", "admin"]}><ManagerDashboard /></Protected>} />
      <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
